var _class;
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
import { action } from "@ember/object";
import { ForcBaseArgs } from "core/components/forc/abstract/base-component";
import CrudJournalEventBaseComponent from "core/components/forc/abstract/crud-journal-event-based-component";
import journalEventRetrievalStrategies from "core/components/forc/utils/journal-event-retrieval-strategies";
import Patient from "core/models/patient";
let CtcaeCustomBaseConsultFormEditionForm = (_class = class CtcaeCustomBaseConsultFormEditionForm extends CrudJournalEventBaseComponent {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "retrieveJournalEvent", journalEventRetrievalStrategies.sourceJournalEvent);
  }
  get currentSections() {
    return [];
  }
  async save() {
    this.changeset.changes.forEach(change => {
      if (!this.currentSections.includes(change.key)) {
        this.changeset.rollbackProperty(change.key);
      }
    });
    return super.save();
  }
  get temperatureSections() {
    if (this.changeset.get("temperatureIssue")) {
      return ["temperatureIssue", "temperature"];
    }
    return ["temperatureIssue"];
  }
  get fatigueSections() {
    if (this.changeset.get("fatigueIssue")) {
      return ["fatigueIssue", "fatigue"];
    }
    return ["fatigueIssue"];
  }
  get coughSections() {
    if (this.changeset.get("coughIssue")) {
      return ["coughIssue", "cough"];
    }
    return ["coughIssue"];
  }
  get breathSections() {
    if (this.changeset.get("breathIssue")) {
      return ["breathIssue", "breath"];
    }
    return ["breathIssue"];
  }
  get weightLossSections() {
    if (this.changeset.get("weightLossIssue")) {
      return ["weightLossIssue", "weightLoss"];
    }
    return ["weightLossIssue"];
  }
  get dermatologicalSections() {
    if (this.changeset.get("dermatologicalIssue")) {
      return ["dermatologicalIssue", ...this.skinRashSections, ...this.itchingSections, "dermatologicalTreatmentEfficient"];
    }
    return ["dermatologicalIssue"];
  }
  get skinRashSections() {
    if (this.changeset.get("skinRashIssue")) {
      return ["skinRashIssue", "skinRashLocation"];
    }
    return ["skinRashIssue"];
  }
  get itchingSections() {
    if (this.changeset.get("itchingIssue")) {
      return ["itchingIssue", "itchingLocation"];
    }
    return ["itchingIssue"];
  }
  get nauseaVomitingSections() {
    if (this.changeset.get("nauseaVomitingIssue")) {
      return ["nauseaVomitingIssue", "nauseaVomiting"];
    }
    return ["nauseaVomitingIssue"];
  }
  get diarrheaSections() {
    if (this.changeset.get("diarrheaIssue")) {
      return ["diarrheaIssue", "diarrhea"];
    }
    return ["diarrheaIssue"];
  }
  get constipationSections() {
    if (this.changeset.get("constipationIssue")) {
      return ["constipationIssue", "constipation", "constipationTreatmentEfficient"];
    }
    return ["constipationIssue"];
  }
  get painSections() {
    if (this.changeset.get("painIssue")) {
      return ["painIssue", "pain"];
    }
    return ["painIssue"];
  }
  get muscularPainSections() {
    if (this.changeset.get("muscularPainIssue")) {
      return ["muscularPainIssue", "muscularPainLevel", "muscularPainLocation", "muscularPainTreatmentEfficient"];
    }
    return ["muscularPainIssue"];
  }
  get articularPainSections() {
    if (this.changeset.get("articularPainIssue")) {
      return ["articularPainIssue", "articularPainLevel", "articularPainLocation", "articularPainTreatmentEfficient"];
    }
    return ["articularPainIssue"];
  }
  get otherPainSections() {
    if (this.changeset.get("otherPainIssue")) {
      return ["otherPainIssue", "otherPainLocation", "otherPainTreatmentEfficient"];
    }
    return ["otherPainIssue"];
  }
  get cortisoneSections() {
    if (this.changeset.get("cortisone")) {
      return ["cortisone", "cortisoneDosageGt20"];
    }
    return ["cortisone"];
  }
}, _applyDecoratedDescriptor(_class.prototype, "save", [action], Object.getOwnPropertyDescriptor(_class.prototype, "save"), _class.prototype), _class);
export { CtcaeCustomBaseConsultFormEditionForm as default };